var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"icon",staticClass:"AnnotationIcon",style:({
    background: _vm.colors[0],
    '--fa-primary-color': 'white',
    '--fa-secondary-color': 'white',
  }),on:{"click":function($event){$event.stopPropagation();return _vm.changeType($event)}}},[(_vm.icon)?_c('Icon',{attrs:{"name":_vm.icon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }